import { render, staticRenderFns } from "./SharedPageBanner.vue?vue&type=template&id=f4e542f4&scoped=true"
import script from "./SharedPageBanner.vue?vue&type=script&lang=js"
export * from "./SharedPageBanner.vue?vue&type=script&lang=js"
import style0 from "./SharedPageBanner.vue?vue&type=style&index=0&id=f4e542f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e542f4",
  null
  
)

export default component.exports